module.exports = __webpack_public_path__ + "static/media/logo-burititocantins.53b45c95.png";